export default {
  rowsPerPage: 25
}



// WEBPACK FOOTER //
// ./src/store/pagination/state.js